import { render, staticRenderFns } from "./TroubleShooting.vue?vue&type=template&id=22736b90&scoped=true&"
import script from "./TroubleShooting.vue?vue&type=script&lang=js&"
export * from "./TroubleShooting.vue?vue&type=script&lang=js&"
import style0 from "./TroubleShooting.vue?vue&type=style&index=0&id=22736b90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22736b90",
  null
  
)

export default component.exports